import React from "react"

import { Grid } from "@mui/material"

import { UseFormReturn } from "react-hook-form"
import {
    t,
} from "@lingui/macro"

import {
    MatesTextField,
    withUseFormHook,
} from "@sinossi/mates-react-library"

import { AdvancedSearchbar } from "components/advanced-searchbar/advanced-searchbar"
import MicrojobberAdvancedSearchValidation, { MicrojobAdvancedSearchForm } from "./form"
import { MicrojobberRequest } from "models"


interface MicrojobAdvancedSearchProps extends UseFormReturn {
    handleCallback: (data: MicrojobberRequest) => void
}
class MicrojobAdvancedSearch extends React.Component<MicrojobAdvancedSearchProps, {}> {
    private onSearch = (data: Record<string, any>): void => {
        const formData: MicrojobAdvancedSearchForm = new MicrojobAdvancedSearchForm()
        Object.assign(formData, data)

        const request: any = formData.toRequest()

        this.props.handleCallback(request)
    }

    render() {
        return (
            <AdvancedSearchbar
                {...this.props}
                searchFieldName="title"
                searchFieldPlaceholder="Ricerca microjobs"
                onSearch={this.onSearch}>
            </AdvancedSearchbar>
        )
    }
}

export default withUseFormHook<{}>(
    MicrojobAdvancedSearch,
    MicrojobberAdvancedSearchValidation,
    new MicrojobAdvancedSearchForm()
)
